// ExtraBlock.jsx
import Block from '../../../components/Block/Block'
import { 
  FaInfoCircle, 
  FaShieldAlt,
  FaWater,
  FaCheckCircle
} from 'react-icons/fa'
import style from './extrablock.module.scss'

const ExtraBlock = () => {
  const branchInfo = {
    description: 'Наш филиал оснащен современным оборудованием и предлагает комфортные условия для тренировок.',
    rules: [
      'Обязательная сменная обувь',
      'Предварительная запись на тренировки',
      'Дети до 14 лет только с сопровождающими'
    ]
  }

  const handleContactClick = () => {
    // Переход на раздел обратной связи сайта
    window.location.href = 'https://sambo-krasnodar.ru/#:~:text=%D0%9E%D0%91%D0%A0%D0%90%D0%A2%D0%9D%D0%90%D0%AF%20%D0%A1%D0%92%D0%AF%D0%97%D0%AC,%D0%9E%D0%A2%D0%9F%D0%A0%D0%90%D0%92%D0%98%D0%A2%D0%AC%20%D0%A1%D0%9E%D0%9E%D0%91%D0%A9%D0%95%D0%9D%D0%98%D0%95'
  }

  return (
    <div className={style.wrapper}>
      <Block
        flexDirection='column'
        justifyContent='start'
        alignItems='start'
        width="75%"
        height='fit-content'
        background="rgba(255, 255, 255, 0.92)"
        header='СВЕДЕНИЯ О ФИЛИАЛЕ'
        className={style.extraBlockWrapper}
      >
        {/* Decorative gradient line */}
        <div className={style.decorativeLine} />
        
        <div className={style.content}>
          {/* Description Section */}
          <section className={style.section}>
            <div className={style.sectionHeader}>
              <div className={style.iconWrapper}>
                <FaWater className={style.sectionIcon} />
              </div>
              <h3 className={style.subheader}>Описание</h3>
            </div>
            <div className={style.descriptionCard}>
              <div className={style.quoteMark}>"</div>
              <p className={style.descriptionText}>
                {branchInfo.description}
              </p>
              <div className={style.descriptionFooter}>
              </div>
            </div>
          </section>

          {/* Rules Section */}
          <section className={style.section}>
            <div className={style.sectionHeader}>
              <div className={style.iconWrapper}>
                <FaShieldAlt className={style.sectionIcon} />
              </div>
              <h3 className={style.subheader}>Правила посещения</h3>
              <span className={style.sectionBadge}>Важно</span>
            </div>
            <div className={style.rulesCard}>
              <ul className={style.rulesList}>
                {branchInfo.rules.map((rule, index) => (
                  <li 
                    key={index} 
                    className={style.ruleItem}
                  >
                    <span className={style.ruleIcon}>
                      <FaCheckCircle />
                    </span>
                    <span className={style.ruleText}>{rule}</span>
                    <span className={style.ruleNumber}>#{index + 1}</span>
                  </li>
                ))}
              </ul>
            </div>
          </section>

          {/* Info Badge with Contact Button */}
          <div className={style.infoBadge}>
            <div className={style.infoIconWrapper}>
              <FaInfoCircle className={style.infoIcon} />
            </div>
            <span>Для получения дополнительной информации обратитесь к администратору</span>
            <button 
              className={style.contactBtn}
              onClick={handleContactClick}
              aria-label="Перейти в раздел обратной связи"
            >
              Связаться
              <span className={style.btnArrow}>→</span>
            </button>
          </div>
        </div>
      </Block>
    </div>
  )
}

export default ExtraBlock